import { AnimatePresence } from "framer-motion"
import React, { Fragment } from "react"
import { Route, useMatch } from "react-router"
import ProtectedRoute from "../ProtectedRoute/ProtectedRoute"

export default function AnimatedSubRoutes({ children }) {
	const routes = []

	React.Children.forEach(children, e => {
		if (e.type !== Route && e.type !== ProtectedRoute) {
			throw new Error("All Children of AnimatedSubRoutes must be a react-router/Route or a ProtectedRoute")
		}
		routes.push({
			type: e.type,
			path: e.props.path,
			element: e.props.element,
			children: e.props.children,
		})
	})

	return (
		<AnimatePresence initial={false}>
			{routes.map(e => {
				// eslint-disable-next-line react-hooks/rules-of-hooks
				const match = useMatch(e.path)
				if (match !== null) {
					if (e.type === ProtectedRoute) {
						return (
							<e.type key={e.path} path={e.path}>
								{e.children}
							</e.type>
						)
					} else {
						return <Fragment key={e.path}>{e.element}</Fragment>
					}
				}
			})}
		</AnimatePresence>
	)
}
